import { createSlice } from '@reduxjs/toolkit';
import { fetchHrisTools } from './actions';

const initialState = {
  isLoading: true,
  data: [],
};

const { reducer } = createSlice({
  name: 'integrations',
  initialState,

  reducers: {},

  extraReducers: {
    [fetchHrisTools.pending]: (state) => {
      state.isLoading = true;
    },
    [fetchHrisTools.fulfilled]: (state, { payload }) => {
      state.data = payload?.data?.tools || [];
      state.isLoading = false;
    },
  },
});

export default reducer;
